/**
 * Types shared between the web app and the server.
 *
 * Anything marked FROZEN must not change after launch — see docs/05-DATA-MODEL.md §8.
 */
export const SHAPE_KINDS = [
    'line',
    'arrow',
    'rectangle',
    'circle',
    'triangle',
    'polygon',
];
export const STICKY_COLORS = [
    'yellow',
    'pink',
    'orange',
    'green',
    'blue',
    'violet',
];
//# sourceMappingURL=types.js.map